<template>
<div class="legal-accept">
  <div class="legal-accept__item"
    @click="toggle('termsAndConditions')"
    >
    <button
      class="legal-accept__item__checkbox"
      :class="{
        'legal-accept__item__checkbox--active': termsAndConditions
      }"
      />

    <div class="legal-accept__item__label"
      v-html="termsAndConditionsLabel"
      />
  </div>

  <div class="legal-accept__item"
    @click="toggle('privacyPolicy')"
    >
    <button
      class="legal-accept__item__checkbox"
      :class="{
        'legal-accept__item__checkbox--active': privacyPolicy
      }"
      />

    <div class="legal-accept__item__label"
      v-html="privacyPolicyLabel"
      />
  </div>

</div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      termsAndConditions: false,
      privacyPolicy: false
    }
  },
  computed: {
    termsAndConditionsLabel () {
      return this.__('I accept the <a href="https://rideq.se/legal" target="blank">terms and conditions</a>.')
    },
    privacyPolicyLabel () {
      return this.__('I accept the <a href="https://rideq.se/legal" target="blank">privacy policy</a>.')
    }
  },
  methods: {
    toggle (type) {
      this[type] = !this[type]
      this.update()
    },
    update () {
      const accepted = this.termsAndConditions === true && this.privacyPolicy === true
      this.$emit('input', accepted)
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  .legal-accept {
    position: relative;
    width: 100%;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    &__item {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: flex-start;
      cursor: pointer;
      margin-top: 10px;

      &__checkbox {
        border-radius: 3px;
        background-color: #fff;
        border: 1px solid #757575;
        height: 15px;
        max-height: 15px;
        width: 15px;
        max-width: 15px;
        cursor: pointer;

        &--active {
          background-color: @color-brand;
          border: 1px solid @color-brand;
        }
      }

      &__label {
        font-size: 12px;
        margin-left: 10px;
      }
    }
  }
</style>
